import { LoadState } from "../../constants/enums";

export interface IMarketingCampaignState {
  whatsAppTemplate: {
    list: IWhatsAppTemplateList[];
    loading: LoadState;
    data: IWhatsAppTemplateData;
    dataLoading: LoadState;
    error: string | null;
  };
  marketCampain: {
    list: IMarketingCampain[];
    loading: LoadState;
    data: IMarketingCampain;
    dataLoading: LoadState;
    error: string | null;
  };
}
export interface IConditionTableRow {
  view: string;
  viewColumn: string;
  column: string;
  operant:
    | "EQUAL"
    | "NOT_EQUAL"
    | "GREATER"
    | "LESSER"
    | "GREATER_THAN_EQUAL"
    | "LESSER_THAN_EQUAL"
    | null;
  columnCompView: string | null;
  columnCompColumn: null;
  columnOrValue: string | null;
  compareColumnValue: string | null;
  isColumnComparison: boolean;
  isCompareWithOldValue: boolean;
}
export interface IMarketingCampain {
  market_campaign_uuid: string | null;
  module_name: string | null;
  module_uuid: string | null;
  campaign_name: string | null;
  campaign_time: string | null;
  ui_module_name: string | null;
  campaign_rule: {
    [key: string]: {
      rows: ICampaignConditionTableRow[];
    };
  }[];
  channel_type: string | null;
  channel_uuid: string | null;
  module_variables_columns_name: string[]
  module_channel_related_columns_name: string[];
  campaign_start_date: string | null;
  campaign_end_date: string | null;
  status: string | null;
  campaign_sql_rule: string;
  create_ts?: string | null;
  insert_ts?: string | null;
  modified_by_name?: string | null;
  modified_by_uuid?: string | null;
  created_by_name?: string | null;
  created_by_uuid?: string | null;
}

export interface ICampaignConditionTableRow {
  viewColumn: string;
  column: string;
  operant:
    | "EQUAL"
    | "NOT_EQUAL"
    | "GREATER"
    | "LESSER"
    | "GREATER_THAN_EQUAL"
    | "LESSER_THAN_EQUAL"
    | null;
  columnCompView: string | null;
  columnCompColumn: null;
  columnOrValue: string | null;
  compareColumnValue: string | null;
  isColumnComparison: boolean;
}


export interface IWhatsAppTemplateList {
  name: string;
  status: string;
  reason: string;
  body: string;
  template_id: string;
}

export interface IWhatsAppTemplateData {
  waba_id?: string | null;
  name: string;
  language: string | null;
  category: string | null;
  components: (
    | IWhatsAppTemplateHeader
    | IWhatsAppTemplateButtons
    | IWhatsAppTemplateFooter
    | IWhatsAppTemplateBody
  )[];
  header: IWhatsAppTemplateHeader;
  body: IWhatsAppTemplateBody;
  buttons: IWhatsAppTemplateButtons;
  footer: IWhatsAppTemplateFooter;
  status?: string | null;
  rejected_reason?: string | null;
}

export interface IWhatsAppTemplatePayload {
  waba_id?: string | null;
  name: string;
  language: string | null;
  category: string | null;
  components: (
    | IWhatsAppTemplateHeader
    | IWhatsAppTemplateButtons
    | IWhatsAppTemplateFooter
    | IWhatsAppTemplateBody
  )[];

  status?: string | null;
  rejected_reason?: string | null;
}

export interface IWhatsAppTemplateHeader {
  type: "HEADER";
  text: string;
}

export interface IWhatsAppTemplateButtons {
  type: "BUTTONS";
  buttons: {
    type: string;
    text: string;
  }[];
}

export interface IWhatsAppTemplateFooter {
  type: "FOOTER";
  text: string;
}

export interface IWhatsAppTemplateBody {
  type: "BODY";
  text: string;
}

export const initialMarketingCampaignState: IMarketingCampaignState = {
  whatsAppTemplate: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      name: "",
      category: null,
      components: [],
      header: {
        type: "HEADER",
        text: "",
      },
      body: {
        type: "BODY",
        text: "",
      },
      buttons: {
        type: "BUTTONS",
        buttons: [],
      },
      footer: {
        type: "FOOTER",
        text: "",
      },
      language: "",
      rejected_reason: "",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  marketCampain: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      market_campaign_uuid: null,
      module_name: null,
      module_uuid: null,
      campaign_time: null,
      campaign_name: null,
      ui_module_name: null,
      campaign_rule: [
        {
          "and": {
            rows: []
          },
        },
      ] as any,
      channel_type: null,
      channel_uuid: null,
      module_variables_columns_name: [],
      module_channel_related_columns_name: [],
      campaign_start_date: null,
      campaign_end_date: null,
      campaign_sql_rule: "",
      status: "ACTIVE",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
};
